import Marquee from "react-fast-marquee";

const hospitals = [
  "Manipal Hospitals, EM Bypass",
  "Manipal Hospitals, Mukundapur",
  "Manipal Hospitals, Broadway",
  "Manipal Hospitals, Saltlake",
  "Lakhotia Diagnostics, Golabari, Howrah",
  "Suraksha Diagnostics, Khoshbagan, Burdwan",
];

export default function HospitalMarquee() {
  return (
    <section
      id="hospitals"
      data-testid="hospitals-section"
      className="py-20 md:py-28 bg-[#F2EFE9]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 mb-12">
        <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[#8FA998] mb-4">
          Hospital Associations
        </p>
        <h2
          data-testid="hospitals-heading"
          className="font-serif text-4xl sm:text-5xl tracking-tight text-[#1E3F33] leading-tight max-w-2xl mb-4"
        >
          Consultation & Treatment Locations
        </h2>
        <p className="text-base sm:text-lg text-[#4A6359] max-w-2xl leading-relaxed">
          Dr. Neha Agarwal is available for consultation and surgical treatment at leading hospitals in Kolkata, equipped with advanced oncology infrastructure.
        </p>
      </div>

      {/* Marquee */}
      <div data-testid="hospital-marquee">
        <Marquee speed={35} gradient gradientColor="#F2EFE9" gradientWidth={80} pauseOnHover>
          {hospitals.map((hospital, i) => (
            <span
              key={i}
              data-testid={`hospital-name-${i}`}
              className="font-serif text-2xl sm:text-3xl text-[#1E3F33] mx-8 whitespace-nowrap"
            >
              {hospital}
              <span className="mx-8 text-[#8FA998]">&bull;</span>
            </span>
          ))}
        </Marquee>
      </div>

      {/* Hospital Cards */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 mt-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {hospitals.slice(0, 4).map((hospital, i) => (
            <div
              key={hospital}
              data-testid={`hospital-card-${i}`}
              className="bg-[#F9F9F6] rounded-2xl p-5 border border-[#D8DDD9] hover:-translate-y-1 hover:shadow-lg hover:shadow-[#1E3F33]/5 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-2">
                <div className="w-2 h-2 rounded-full bg-[#8FA998]" />
                <span className="text-xs font-semibold tracking-widest uppercase text-[#8FA998]">
                  {i < 4 ? "Surgery & OPD" : "OPD Only"}
                </span>
              </div>
              <p className="font-serif text-lg text-[#1E3F33] font-medium">{hospital}</p>
            </div>
          ))}
          {hospitals.slice(4).map((hospital, i) => (
            <div
              key={hospital}
              data-testid={`hospital-card-opd-${i}`}
              className="bg-[#F9F9F6] rounded-2xl p-5 border border-[#D8DDD9] hover:-translate-y-1 hover:shadow-lg hover:shadow-[#1E3F33]/5 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-2">
                <div className="w-2 h-2 rounded-full bg-[#C29F60]" />
                <span className="text-xs font-semibold tracking-widest uppercase text-[#C29F60]">
                  OPD Consultation Only
                </span>
              </div>
              <p className="font-serif text-lg text-[#1E3F33] font-medium">{hospital}</p>
            </div>
          ))}
        </div>
        <div className="mt-8 text-center">
          <a
            href="/book-appointment"
            data-testid="hospitals-book-btn"
            className="inline-flex items-center gap-2 bg-[#1E3F33] text-[#F9F9F6] px-7 py-3.5 rounded-full text-sm font-semibold hover:bg-[#2C5545] transition-colors duration-200"
          >
            Book Appointment at Preferred Location
          </a>
        </div>
      </div>
    </section>
  );
}
